import { NetworkParticipationMatrix } from '@components/network/NetworkParticipationMatrix'

// Standalone National Agreement Network page. The matrix itself derives its
// read-only vs editable state from the current user's admin status, so this page
// stays a thin host with the page-level heading enabled.
export const NetworkPage = () => {
  return <NetworkParticipationMatrix showHeading />
}
